import { FC, useEffect } from 'react';
import { Style } from '@capacitor/status-bar';

import {
	Footer,
	MainWithFooterTemplate,
	useStatusBarStyleSync,
} from '@mopla/ui';
import { ContentWrapper } from '@mopla/ui/layouts/WelcomeScreen';

import { PushToApp } from '../../../../organisms/PushToAppScreen/PushToApp';
import { WelcomeStep } from '../../constants';
import { useWelcomePageStoreContext } from '../../useWelcomePageStore';

export const TryOurApp: FC = () => {
	const { activeStep } = useWelcomePageStoreContext();
	const isStepShown = activeStep === WelcomeStep.tryOurApp;

	const { push, pop } = useStatusBarStyleSync();

	useEffect(() => {
		push({
			title: 'TryOurApp',
			style: Style.Light,
		});

		return () => {
			pop();
		};
	}, [push, pop, isStepShown]);

	return (
		<PushToApp
			render={({ content, submit }) => (
				<MainWithFooterTemplate
					className="mainWithFooter"
					content={<ContentWrapper>{content}</ContentWrapper>}
					footer={<Footer>{submit}</Footer>}
				/>
			)}
		/>
	);
};
